export const SnapshotChunkType = {
  Start: 'Start',
  Chunk: 'Chunk',
  End: 'End',
} as const;

export type SnapshotChunkType = (typeof SnapshotChunkType)[keyof typeof SnapshotChunkType];
